<script>
	// Services
	import { notify } from '@/Services/Notify.js';
	// Components
	import TextInput from '@/Components/TextInput.svelte';
	import PhoneInput from '@/Components/PhoneInput.svelte';
	import CountrySelector from '@/Components/CountrySelector.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Stores
	import AdminUserStore from '@/Stores/AdminUserStore.js';

	export let data;

	let errors = {};
	let sending = false;
	let formData = {
		phone: data.phone,
		country: data.country
	};

	function handleSubmit() {
		sending = true;
		AdminUserStore.patchCurrent(formData)
			.then(() => {
				errors = {};
				notify({
					type: 'success',
					title: `Admin user : ${data.name}`,
					message: 'Profile successfully updated',
					timeout: 3
				});
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error occurred',
					message: (e && e.error && e.error.length > 0 && e.error[0]) || 'Problem updating your profile',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
			});
	}
</script>

<div class="md:mx-2 w-full md:w-1/3 rounded-b bg-gray-100">
	<div class="flex items-center px-2 bg-dark-grey text-light rounded-t">
		<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">User details</h2>
	</div>
	<div class="mt-2 px-4">
		<form on:submit|preventDefault={handleSubmit}>
			<div class="grid grid-cols-3 rounded-b">
				<div class="col-start-1 px-2 pb-4 w-full pt-4">First name</div>
				<div class="px-2 py-2 col-span-2">
					<TextInput
						bind:value={data.first_name}
						className="pb-4 w-full"
						disabled={true}
						name="profile_firstname"
						type="text"
					/>
				</div>
				<div class="col-start-1 px-2 pb-4 w-full pt-4">Last name</div>
				<div class="px-2 py-2 col-span-2">
					<TextInput
						bind:value={data.last_name}
						className="pb-4 w-full"
						disabled={true}
						name="profile_lastname"
						type="text"
					/>
				</div>
				<div class="col-start-1 px-2 pb-4 w-full pt-4">Username</div>
				<div class="px-2 py-2 col-span-2">
					<TextInput bind:value={data.name} className="pb-4 w-full" disabled={true} name="profile_name" type="text" />
				</div>
				<div class="col-start-1 px-2 pb-4 w-full pt-4">Email</div>
				<div class="px-2 py-2 col-span-2">
					<TextInput
						bind:value={data.email}
						className="pb-4 w-full"
						disabled={true}
						name="profile_email"
						type="email"
					/>
				</div>
				<div class="col-start-1 px-2 pb-4 w-full pt-4">Phone</div>
				<div class="px-2 py-2 col-span-2">
					<PhoneInput
						bind:country={formData.country}
						bind:value={formData.phone}
						className="pb-4 w-full"
						name="profile_phone"
						required="true"
						type="text"
						errors={errors && errors.phone}
					/>
				</div>
				<div class="col-start-1 px-2 pb-4 w-full pt-4">Country</div>
				<div class="px-2 py-2 col-span-2">
					<CountrySelector
						bind:value={formData.country}
						className="pb-4 w-full"
						name="profile_country"
						required="true"
						errors={errors && errors.country}
					/>
				</div>
				<div class="px-2 py-2 col-span-2" />
				<div class="w-full items-end justify-end pr-2 pb-6">
					<LoadingButton type="submit" loading={sending} className="btn btn-black mx-auto w-full">Update</LoadingButton>
				</div>
			</div>
		</form>
	</div>
</div>
